import React from "react";
import { Controller, useForm } from "react-hook-form";
import { Customer, EmailAddress } from "../../../../core/api/models";
import { toastr } from "react-redux-toastr";
import CustomerEmail from "../../../../components/customer-email";
import api from "../../../../api";

const SearchCustomer: React.FunctionComponent<{
  error?: string;
  onClose: () => void;
  updateUser: (details: Customer) => void;
  customerDetails?: Customer;
}> = (props) => {
  const { control, handleSubmit } = useForm<Customer>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const ValidateEmail = (mail: string) => {
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        mail
      )
    ) {
      return true;
    }

    return false;
  };

  const onSubmit = async (data?: any) => {
    let isValid = true;
    data?.emails?.forEach((item: { email: string }) => {
      if (!ValidateEmail(item.email)) {
        isValid = false;
      }
    });
    if (!data?.emails || data?.emails?.length === 0) {
      toastr.error("Error", "Email required");
      return;
    }
    if (!isValid) {
      toastr.error("Error", "Each email should be valid");
      return;
    }
    const updateData: Customer = {
      prefix: props.customerDetails?.prefix,
      firstName: props.customerDetails?.firstName,
      lastName: props.customerDetails?.lastName,
      emails: data?.emails,
    };
    try {
      const response = await api.customer.updateCustomer(
        updateData,
        props.customerDetails?._id
      );
      props.updateUser(response);
      props.onClose();
      toastr.success("Success", "Email saved successfully");
    } catch (error) {
      if (error?.response?.data?.data?.message) {
        toastr.error("Error", error?.response?.data?.data?.message.join());
      } else {
        toastr.error("Error", error?.response?.data?.message);
      }
    }
  };

  const onUpdate = async (phones: EmailAddress[]) => {
    const updateData: Customer = {
      prefix: props.customerDetails?.prefix,
      firstName: props.customerDetails?.firstName,
      lastName: props.customerDetails?.lastName,
      emails: phones,
    };
    const response = await api.customer.updateCustomer(
      updateData,
      props.customerDetails?._id
    );
    props.updateUser(response);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="d-flex flex-wrap px-4 py-1 contact-form-row active border-top border-bottom">
        <div className="col pl-0 pr-2 contact-label font-xs text-gray-500 pt-2">
          E-mail
        </div>
        <div className="col pl-2 pr-0 contact-content d-flex align-items-center flex-wrap">
          <Controller
            control={control}
            // rules={{ required: true }}
            name="emails"
            defaultValue={props.customerDetails?.emails}
            render={({ onChange, value }) => (
              <CustomerEmail
                className="form-control p-0 rounded-sm font-weight-semibold"
                placeholder="Phone"
                value={value}
                onChange={onChange}
                isEdit
                onUpdate={onUpdate}
              />
            )}
          />
        </div>
        <div className="col-12 pl-2 pr-0 mt-1 text-right">
          <button
            className="btn btn-sm btn-outline-dark mr-1 font-normal"
            onClick={props.onClose}
          >
            Cancel
          </button>
          <button className="btn btn-sm btn-primary font-normal">Save</button>
        </div>
      </div>
    </form>
  );
};

export default SearchCustomer;
